import { render, staticRenderFns } from "./ShortMessageComment.vue?vue&type=template&id=4cfcf17e"
import script from "./ShortMessageComment.vue?vue&type=script&lang=js"
export * from "./ShortMessageComment.vue?vue&type=script&lang=js"
import style0 from "./ShortMessageComment.vue?vue&type=style&index=0&id=4cfcf17e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports